/**
 * Decides which payment buttons to show on the customer (patron) app.
 *
 * - Pay Online  → outlet allows self payment AND Fiuu or Revenue Monster is set up
 * - Pay At Counter → outlet allows pay at counter (selfPayAtCounter)
 */

type OutletCustomerPolicy = {
	selfPayment?: boolean | null;
	selfPayAtCounter?: boolean | null;
};

type OutletForPatronPayment = {
	customerPolicy?: OutletCustomerPolicy | null;
};

export type PatronPaymentOptions = {
	showPayOnline: boolean;
	showPayAtCounter: boolean;
};

export function getPatronPaymentOptions(
	outlet: OutletForPatronPayment | null | undefined,
	isOnlinePaymentAvailable: boolean,
): PatronPaymentOptions {
	const selfPayment = Boolean(outlet?.customerPolicy?.selfPayment);
	const selfPayAtCounter = Boolean(outlet?.customerPolicy?.selfPayAtCounter);

	return {
		showPayOnline: selfPayment && isOnlinePaymentAvailable,
		showPayAtCounter: selfPayAtCounter,
	};
}
